// tanstack
import { createFileRoute } from '@tanstack/react-router';

// components
import PowerBasic from '@/features/dashboards/layouts/PowerBasic';
import ErrorBoundary from '@/routes/-ErrorBoundary';

export const Route = createFileRoute(
  '/$accountId/_user/dashboards/power-basic',
)({
  component: PowerBasic,
  errorComponent: ErrorBoundary,
  staticData: { crumb: 'dashboards-power-basic:title' },
});
